import * as z from "zod";
import { askRedoExplorerFilters } from "./get-explorer-threads";

export const getAskRedoExplorerAggregates = {
  name: "getAskRedoExplorerAggregates" as const,

  input: askRedoExplorerFilters,

  output: z.object({
    totalThreads: z.number(),
    escalatedCount: z.number(),
    avgMessagesPerThread: z.number(),
    totalTokens: z.number(),
    daily: z.array(
      z.object({ date: z.string(), total: z.number(), escalated: z.number() }),
    ),
    skillCounts: z.record(z.string(), z.number()),
    toolCounts: z.record(z.string(), z.number()),
    productAreaCounts: z.record(z.string(), z.number()),
    merchantCounts: z.array(
      z.object({
        teamId: z.string().nullable(),
        teamName: z.string().nullable(),
        count: z.number(),
        escalated: z.number(),
      }),
    ),
  }),
};
